module.exports = {
 APP_ENVIRONMENT: "production",
 APP_PORT: 8080
};
